var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"config-dynamic-input",style:(_vm.inputStyle),attrs:{"type":"time"},domProps:{"value":_vm.displayValue},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }